<div class="live-container">
  <!-- <div class="title">{{ currentChannel?.name }} Live Panel</div> -->
  <div class="main">
    <div class="working-space" #liveFeedPreviewContainer>
      <div class="players-wrapper" [class.video-loaded]="isLiveFeedVideoLoaded">
        <div class="player-title preview">
          <span>{{ getLiveFeedPreviewTitle() }}</span>
        </div>
        <video
          #liveFeedPreview
          autoplay
          *ngIf="currentLiveFeedPreview"
          class="webrtc-preview video"
          [poster]="'/assets/stream-preview-loader.gif'"
          [webrtc-src]="currentLiveFeedPreview"
          (refreshChannelPreview)="onRefreshLiveFeedPreview()"
          [muted]="true"
          (loadedmetadata)="
            adjustAspectRatio(liveFeedPreviewContainer, liveFeedPreview)
          "
        ></video>
        <div
          *ngIf="!currentLiveFeedPreview"
          class="webrtc-preview no-input-data"
        >
          NO INPUT DATA
        </div>
      </div>
      <div class="info-card main-card">
        <div class="info-card-title">Next Item</div>
        <div
          class="info-card-content"
          [style.direction]="
            isLeftOrRightDirection(nextShow?.name ?? 'No upcoming item')
          "
          title="{{ nextShow ? nextShow.name : 'No upcoming item' }}"
        >
          {{ nextShow ? nextShow.name : "No upcoming item" }}
        </div>
        <div class="info-card-content-fields">
          <table>
            <tr>
              <span class="details-key bold">Time Till Next Live:</span>
              <span class="details-value bold">{{
                formatDuration(timeTillNextLiveMs, null)
              }}</span>
            </tr>
            <tr>
              <span class="details-key bold">Break Duration:</span>
              <span class="details-value bold">{{
                breakDuration ? breakDuration : "00:00:00"
              }}</span>
            </tr>

            <tr>
              <span class="details-key">Break Start Time:</span>
              <span class="details-value">{{ getBreakStartTime() }}</span>
            </tr>
            <tr>
              <span class="details-key">Break End Time:</span>
              <span class="details-value">{{
                breakDurationEndTime
                  ? breakDurationEndTime.format("HH:mm:ss")
                  : "00:00:00"
              }}</span>
            </tr>
          </table>
        </div>
      </div>
      <div class="info-card" style="flex: 0 0 25%">
        <div class="info-card-title">Next Live</div>
        <div
          class="info-card-content"
          [style.direction]="
            isLeftOrRightDirection(getNextLivePanelTitle())
          "
          title="{{ getNextLivePanelTitle() }}"
        >
          {{ getNextLivePanelTitle() }}
        </div>
        <div
          class="buttons-wrapper"
          style="justify-content: space-around; gap: 0"
        >
          <button
            class="button red"
            #skipToNextLiveButton
            [disabled]="isBroadcastPresetShow(nextLiveOrBroadcastSlot)"
            [title]="
              duringSkipToOperation ? 'processing skip...' : 'Skip to next live'
            "
            (mousedown)="onButtonMouseDown($event)"
            (click)="
              !duringUpdatePrerollOrSkip &&
                isLiveShowSlot(nextLiveOrBroadcastSlot) &&
                skipToClicked(
                  skipToNextLiveButton,
                  false,
                  true,
                  nextLiveOrBroadcastSlot
                )
            "
            [class.during-skip]="duringUpdatePrerollOrSkip"
          >
            <span>Skip to next live</span>
          </button>
          <button
            class="button red emergency-skip"
            #skipToNextLiveEmergencyButton
            [disabled]="isBroadcastPresetShow(nextLiveOrBroadcastSlot)"
            [title]="
              duringSkipToOperation
                ? 'processing skip...'
                : 'Emergency skip to next live'
            "
            (mousedown)="onButtonMouseDown($event)"
            (click)="
              !duringUpdatePrerollOrSkip &&
                isLiveShowSlot(nextLiveOrBroadcastSlot) &&
                skipToClicked(
                  skipToNextLiveEmergencyButton,
                  true,
                  true,
                  nextLiveOrBroadcastSlot
                )
            "
            [class.during-skip]="duringUpdatePrerollOrSkip"
          >
            <span>Emergency skip to next live</span>
          </button>
        </div>
      </div>
    </div>
    <div class="working-space" #programPreviewContainer>
      <div class="players-wrapper" [class.video-loaded]="isProgramVideoLoaded">
        <div class="player-title program">
          <span>Program</span>
          <span *ngIf="duringSkipToOperation"> - PROCESSING SKIP...</span>
        </div>
        <video
          #programPreview
          autoplay
          *ngIf="currentChannelPreview"
          class="webrtc-preview video"
          [poster]="'/assets/stream-preview-loader.gif'"
          [webrtc-src]="currentChannelPreview"
          (refreshChannelPreview)="onRefreshChannelPreview()"
          [muted]="true"
          (loadedmetadata)="
            adjustAspectRatio(programPreviewContainer, programPreview)
          "
        ></video>
        <div
          *ngIf="!currentChannelPreview"
          class="webrtc-preview no-input-data"
        >
          NO INPUT DATA
        </div>
      </div>

      <div class="info-card">
        <div class="info-card-title">Now Playing</div>
        <div
          class="info-card-content"
          [title]="currentShow ? currentShow.name : 'No upcoming item'"
          [style.direction]="
            isLeftOrRightDirection(currentShow?.name ?? 'No upcoming item')
          "
        >
          {{ currentShow ? currentShow.name : "No upcoming item" }}
        </div>
        <div class="info-card-content-fields">
          <table>
            <tr>
              <span class="details-key bold">Current Time:</span>
              <span class="details-value bold">{{
                formatDuration(currentShowElaplsedTimeMs, null)
              }}</span>
            </tr>
            <tr>
              <span class="details-key bold">Remaining Time:</span>
              <span class="details-value bold">{{
                formatDuration(currentShowRemainingTimeMs, null)
              }}</span>
            </tr>
            <tr>
              <span class="details-key">Start Time:</span>
              <span class="details-value">{{
                currentShowStartTime
                  ? currentShowStartTime.format("HH:mm:ss")
                  : "00:00:00"
              }}</span>
            </tr>
            <tr>
              <span class="details-key">End Time:</span>
              <span class="details-value">{{
                currentShowEndTime
                  ? currentShowEndTime.format("HH:mm:ss")
                  : "00:00:00"
              }}</span>
            </tr>
          </table>
        </div>
        <div class="buttons-wrapper with-gap">
          <button
            class="button regular"
            #skipToNextItemButton
            [disabled]="isBroadcastPresetShow(nextShow)"
            [title]="
              duringSkipToOperation ? 'processing skip...' : 'Skip to next item'
            "
            (mousedown)="onButtonMouseDown($event)"
            (click)="
              !duringUpdatePrerollOrSkip &&
                !isBroadcastPresetShow(nextShow) &&
                skipToClicked(skipToNextItemButton, false, false, nextShow)
            "
            [class.during-skip]="duringUpdatePrerollOrSkip"
          >
            <span>Skip to next item</span>
          </button>
          <button
            class="button red"
            style="flex: 0.23"
            #skipToNextItemEmergencyButton
            [disabled]="isBroadcastPresetShow(nextShow)"
            [title]="
              duringSkipToOperation
                ? 'processing skip...'
                : 'Emergency skip to next item'
            "
            (mousedown)="onButtonMouseDown($event)"
            (click)="
              !duringUpdatePrerollOrSkip &&
                !isBroadcastPresetShow(nextShow) &&
                skipToClicked(
                  skipToNextItemEmergencyButton,
                  true,
                  false,
                  nextShow
                )
            "
            [class.during-skip]="duringUpdatePrerollOrSkip"
          >
            <span> Emergency skip to next item</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
